export default {
  toast_messages: {
    google_review_uploaded: 'La tua recensione è stata verificata. Hai guadagnato {{points}} punti 😉',
  },
};
